export const CONSENT_STORAGE_KEY = 'dawntech.analytics.consent';
export const CONSENT_VERSION = 1;
export const CONSENT_EVENT = 'dawntech:analytics-consent-changed';

export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_REJECTED = 'rejected';

const isBrowser = () => typeof window !== 'undefined';

const getStorage = () => {
  if (!isBrowser()) {
    return null;
  }

  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

export const getStoredConsent = () => {
  const storage = getStorage();

  if (!storage) {
    return null;
  }

  try {
    const stored = JSON.parse(storage.getItem(CONSENT_STORAGE_KEY));

    if (
      stored &&
      stored.version === CONSENT_VERSION &&
      [CONSENT_ACCEPTED, CONSENT_REJECTED].includes(stored.choice)
    ) {
      return stored.choice;
    }
  } catch (error) {
    return null;
  }

  return null;
};

const notifyConsentChange = (choice, revoked = false) => {
  if (!isBrowser() || typeof window.dispatchEvent !== 'function') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(CONSENT_EVENT, {
      detail: { choice, revoked },
    }),
  );
};

export const saveConsent = (choice) => {
  if (![CONSENT_ACCEPTED, CONSENT_REJECTED].includes(choice)) {
    return false;
  }

  const storage = getStorage();

  try {
    storage?.setItem(
      CONSENT_STORAGE_KEY,
      JSON.stringify({
        version: CONSENT_VERSION,
        choice,
      }),
    );
  } catch (error) {
    return false;
  }

  notifyConsentChange(choice);
  return true;
};

export const revokeConsent = () => {
  const storage = getStorage();

  try {
    storage?.removeItem(CONSENT_STORAGE_KEY);
  } catch (error) {
    // Analytics must never prevent the privacy control from closing.
  }

  notifyConsentChange(null, true);
};
